<template>

    <modal-container class="modal-container--short" :resetOnUpdate="true">

        <template>

            <component :is="checkoutComponent" @changeContent="update($event)" v-bind="{params: checkoutParams}"></component>

        </template>

    </modal-container>

</template>

<script>
    const SelectProvince = Vue.component('container_province', require('./_province.vue').default);
    const SelectCity = Vue.component('container_city', require('./_city.vue').default);

    export default {

        props: {
            params: {
                default: null,
            },
        },

        data: function () {
            return {
                checkoutComponent: null,
                checkoutParams: null,
            }
        },

        methods: {

            update(event) {
                this.checkoutParams = event

                var currComponent

                switch (event.page) {
                    case 'cities':
                        this.checkoutComponent = SelectCity;
                        break;
                    case 'provinces':
                    default:
                        this.checkoutComponent = SelectProvince;
                        break;
                }
            }

        },

        created: function() {
            this.update(this.params)
        }
    }
</script>
